import { render, staticRenderFns } from "./VxButton.vue?vue&type=template&id=18a87160&"
import script from "./VxButton.vue?vue&type=script&lang=js&"
export * from "./VxButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports